import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {environment} from '../../../../environments/environment';

const mockCover = (function*() {
  let i = 0;
  while (true) {
    yield `assets/mocks/${i % 13 + 1}.svg`;
    i++;
  }
})();

@Component({
  selector: 'mwo-smart-cover',
  templateUrl: './smart-cover.component.html',
  styleUrls: ['./smart-cover.component.scss', './family.scss', './library.scss', './playlist.scss', './group.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SmartCoverComponent implements OnInit {
  @Input() item: {
    icon?: string ;
    artwork?: string;
    id: string
    event: {
      color: string
    }
    title: string;
    name: string;
    cover: string;
    color: string;
    backgroundColor: string;
    isNew: boolean;
    libraryTopicType: string;
  } | any;
  @Input() coverTitle: string;
  @Input() coverSrc: string | void;
  @Input() mode = 'playlist';
  @Input() isSearchPage = false;
  @Input() color: string;
  @Input() loadingCard: boolean = false;
  backgroundColor: string;
  cover: string | void;
  mock: string | void;

  constructor() { }


  ngOnInit() {
    if (this.item != null) {
      this.backgroundColor = this.item.color || this.color;
      this.cover = this.item.artwork || this.item.cover;
      this.mock = mockCover.next().value;
      if (!this.coverTitle) {
        this.coverTitle = this.item.title || this.item.name;
      }
      this.loadCover();
    }
  }

  private loadCover() {
    if (this.item.wishlist) {
      this.coverSrc = 'assets/icons/MW-WISHLIST-POCHETTE.png';
      return;
    }

    if (environment.enableDesktopMode) {
      if (this.item.artwork || this.item.icon) {
        if (this.item.id === 'scheduler') {
          this.coverSrc = this.item.artwork;
          return;
        }
        if (this.item.artwork?.includes('png') || this.item.icon?.includes('png')) {
          this.coverSrc = `${environment.remoteApi}/${environment.apiVersion}/media/artwork/${this.item.id}?extension=png`;
        } else {
          this.coverSrc = `${environment.remoteApi}/${environment.apiVersion}/media/artwork/${this.item.id}`;
        }
      }
      if (!this.coverSrc) {
        this.coverSrc = `${environment.remoteApi}/${environment.apiVersion}/media/artwork/${this.item.id}?extension=png`;
      }
    } else {
      if (!this.coverSrc) {
        this.coverSrc = this.cover;
      }
    }
  }

  applyPattern(url: string) {
    return url?.includes('asset');
  }
}
